import AnalyticsDashboard from '@/components/analytics/AnalyticsDashboard'
import { useTenant } from '@/contexts/TenantContext'

const Analytics: React.FC = () => {
  const { currentTenant } = useTenant()

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">B2B Analytics</h1>
        <p className="text-gray-600 mt-1">Track your content performance and audience insights</p>
      </div>
      
      <AnalyticsDashboard tenantId={currentTenant?.id} />
    </div>
  )
}

export default Analytics 